import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { format } from "date-fns";
import { ru } from "date-fns/locale";
import styles from "../styles/form.module.css";
import Dropdown from "@/shared/ui/Dropdown/Dropdown";
import { getMe } from "@/entities/user/api/userApi.js";
import {getGameInfo, getGames, getMaxPointsForGame, payForBooking} from "../api/formApi";
import { FadeIn } from "@/shared/ui/animations";
import Modal from "@/shared/ui/Modal";
import PrivacyAgreement from "@/shared/ui/PrivacyAgreement";
import ToggleInputGroup from "@/shared/ui/ToggleInputGroup";
import RadioButton from "@/shared/ui/RadioButton/index.js";
import PlayersModal from "@/widgets/formSection/components/PlayersModal.jsx";

// --- словарь кастомных подписей для разных систем -------------
const MODAL_CONTENT_BY_SYSTEM = {
    "Cyberpunk Red": {
        text: "Постой, чумба. А ты точно часть этой истории, а не просто хочешь врезать кому-то без контекста?",
        confirm: "Да, это моя миссия",
        cancel: "Отбой, чумба",
        isCyber: true
    },
};

// --------------------------------------------------------------

const Form = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const gameIdFromCard = location.state?.gameId;

    const [isLoading, setIsLoading] = useState(true);
    const [profile, setProfile] = useState(null);
    const [games, setGames] = useState([]);
    const [selectedGame, setSelectedGame] = useState(null);

    const [selectedGameInfo, setSelectedGameInfo] = useState(null);

    const [privacyAccepted, setPrivacyAccepted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isCompletedRegistered, setIsCompletedRegistered] = useState(false);

    // ----------- Количество людей --------------
    const GOING_ALONE = "alone";
    const GOING_WITH_FRIEND = "withFriend";

    const [isSolo, setIsSolo] = useState(true);
    const [isModeModalOpen, setIsModeModalOpen] = useState(false);
    //-------------------------------------------------------

    //--------------------Модалка добавления друзей---------------
    const [friendIds, setFriendIds] = useState([""]);
    const [isCyber,setIsCyber] = useState(false);
    //-----------------------------------------------------------

    // ----------- Баллы ----------------------------
    const [usePoints, setUsePoints] = useState(false);
    const [pointsInput, setPointsInput] = useState("");
    const [maxPoints, setMaxPoints] = useState(0);
    // -----------------------------------------------------------

    // ----------- Промокод ----------------------------------
    const [usePromo, setUsePromo] = useState(false);
    const [promoCode, setPromoCode] = useState(null);
    // -----------------------------------------------------------

    // ----------- состояние модалки ----------------------------
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalText, setModalText] = useState("");
    const [modalConfirmText, setModalConfirmText] = useState("");
    const [modalCancelText, setModalCancelText] = useState("");
    // -----------------------------------------------------------

    // ----------- получение профиля + списка игр ----------------------------------
    useEffect(() => {
        (async () => {
            try {
                const data = await getMe();
                if (data?.fio !== null) setProfile(data);
                setIsCompletedRegistered(data?.registrationCompleted === false);
            } catch {
                setProfile(null);
            }
            try {
                const response = await getGames();
                const arr = Array.isArray(response) ? response : response.data;
                setGames(Array.isArray(arr) ? arr : []);
            } catch {
                console.error("Ошибка при получении игр");
            } finally {
                setIsLoading(false);
            }
        })();
    }, []);

    // ─── Получаем колличество доступных баллов для выбранной игры ──────────────
    useEffect(() => {
        if (selectedGame) getMaxPoints(selectedGame?.id)
    }, [selectedGame]);

    // ─── докручиваем редирект на доп. регистрацию ──────────────
    useEffect(() => {
        if (isCompletedRegistered) navigate("/auth/complete-reg");
    }, [isCompletedRegistered, navigate]);

    // ─── проставляем игру, если пришли из карточки ─────────────
    useEffect(() => {
        if (gameIdFromCard && games.length) {
            const found = games.find((g) => g.id === gameIdFromCard);
            if (found) setSelectedGame(found);
            window.history.replaceState(
                {},
                document.title,
                window.location.pathname + window.location.search + window.location.hash
            );
        }
    }, [gameIdFromCard, games]);

    // ─── получение максимального количества баллов ─────────────
    const getMaxPoints = async (gameId) => {
        try {
            const res = await getMaxPointsForGame(gameId)
            const data = res.data;
            setMaxPoints(data.points);
        }catch (error) {
            console.error(error)
        }
    }


    const handleGoingPlayer = () => {
        setIsModeModalOpen(false);
    }

    // Инпуты

    const togglePoints = () => {
        setUsePoints((prev) => {
            if (!prev) setUsePromo(false); // отключаем промокод
            return !prev;
        });
    };

    const togglePromo = () => {
        setUsePromo((prev) => {
            if (!prev) setUsePoints(false); // отключаем баллы
            return !prev;
        });
    };

    useEffect(() => {
        const parsed = parseInt(pointsInput);

        if (isNaN(parsed)) {
            if (pointsInput !== "0") setPointsInput("0");
            return;
        }

        if (parsed > maxPoints) {
            if (pointsInput !== maxPoints.toString()) setPointsInput(maxPoints.toString());
        } else if (parsed < 0) {
            if (pointsInput !== "0") setPointsInput("0");
        }else {
            setPointsInput(parsed.toString());
        }
    }, [pointsInput, maxPoints]);


    const fetchGameInfo = async (gameId) => {
        try {
            const { data } = await getGameInfo(gameId);
            return data; // возвращаем data
        } catch (err) {
            toast.error(err?.response?.data?.message || "Не удалось получить данные игры");
            return null; // возвращаем null при ошибке
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            if (selectedGame) {
                const gameInfo = await fetchGameInfo(selectedGame.id);
                if (gameInfo) {
                    const content = MODAL_CONTENT_BY_SYSTEM[gameInfo?.gameSystemName];
                    if (gameInfo.accessType === "CLOSE") {
                        setModalText(content?.text || "ты точно из этой партии, герой? или просто проходил мимо с мечом?");
                        setModalConfirmText(content?.confirm || "Я с вами, клянусь кубами!");
                        setModalCancelText(content?.cancel || "Ошибся таверной...");
                    }

                    setIsCyber(content?.isCyber || false);
                    setSelectedGameInfo(gameInfo);
                }
            }
        };
        fetchData();
    }, [selectedGame]);

    // ─── оплата  ───────────────────────────────────────
    const pay = async () => {
        if (!selectedGame) return toast.error("Пожалуйста, выберите игру.");
        setIsSubmitting(true);
        try {
            const { data } = await payForBooking(
                friendIds,
                selectedGame.id,
                usePoints,
                usePoints ? parseInt(pointsInput) : 0,
                usePromo,
                usePromo ? promoCode : null,
                isSolo,

            );
            if (data?.url) window.location.href = data.url;
            else toast.error("Ссылка на оплату не получена.");
        } catch (err) {
            toast.error(err?.response?.data?.message || "Ошибка при инициации оплаты.");
        } finally {
            setIsSubmitting(false);
        }
    };

    /*
        * ------------------------------
        * главный submit
        * -----------------------------
    */
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!profile) return navigate("/auth");
        if (!selectedGame) return toast.error("Пожалуйста, выберите игру.");

        setIsLoading(true);
        try {
            if (selectedGameInfo?.accessType === "CLOSE") {
                setIsModalOpen(true);
            } else {
                await pay();
            }
        } catch (err) {
            toast.error( err?.response?.data?.message ||"Не удалось получить данные игры.");
        } finally {
            setIsLoading(false);
        }
    };

    // ─── тело компонента ───────────────────────────────────────
    return (
        <>
            <FadeIn delay={100}>
                <form className={styles.form} onSubmit={handleSubmit}>

                    <FadeIn delay={200}>
                        <p className={`${styles.formText} body text-center`}>
                            Для записи на игру необходимо внести предоплату. Окно оплаты
                            откроется автоматически после заполнения формы.
                        </p>
                        <p className={`${styles.formText} body text-center`}>
                            Предоплата не возвращается в случае отмены вами записи менее, чем за 48 часов.
                        </p>
                    </FadeIn>

                    <div className={"row g-0 gap-5"}>
                        <div className={"col-auto"}>
                            <RadioButton
                                value={GOING_ALONE}
                                name="goingMode"
                                isChecked={isSolo}
                                onChange={()=> {
                                    setIsSolo(!isSolo)
                                }}
                                label="Иду один"
                                option={true}
                            />
                        </div>

                        <div className={"col-auto"}>
                            <RadioButton
                                value={GOING_WITH_FRIEND}
                                name="goingMode"
                                isChecked={!isSolo}
                                onChange={()=> {
                                    setIsSolo(!isSolo)
                                }}
                                label="Иду с другом"
                                option={false}
                            />
                        </div>
                    </div>
                    <input
                        className="input"
                        type="text"
                        placeholder="Имя"
                        value={
                            profile
                                ? `${profile.name || ""} ${profile.surname || ""}`.trim()
                                : ""
                        }
                        disabled
                    />

                    <input
                        className="input"
                        type="text"
                        placeholder="Номер телефона"
                        value={profile?.phone || ""}
                        disabled
                    />

                    <Dropdown
                        options={games}
                        selected={selectedGame}
                        onSelect={(game) => {
                            setSelectedGame(game);
                            fetchGameInfo(game.id);
                        }}
                        getLabel={(o) => o.title}
                        getValue={(o) => o.id}
                        renderDescription={(o) =>
                            format(new Date(o.startedAt), "dd.MM.yyyy HH:mm", { locale: ru })
                        }
                        placeholder="Выберите игру"
                    />



                    {selectedGame && (<>
                        {
                            !isSolo && (
                                <button
                                    className={`btn btn-green-outline w-100 mb-3`}
                                    type="button"
                                    onClick={setIsModeModalOpen}
                                >
                                    {friendIds.filter(el => el.trim() !== "").length ? "Посмотреть " : "Добавить "}
                                    игроков
                                </button>
                            )
                        }



                        <ToggleInputGroup
                            label="Списать баллы"
                            isEnabled={usePoints}
                            onToggle={togglePoints}
                            inputValue={pointsInput}
                            onInputChange={(e) => setPointsInput(e.target.value)}
                            maxPoints={parseInt(maxPoints)}
                        />

                        <ToggleInputGroup
                            label="Использовать промокод"
                            isEnabled={usePromo}
                            onToggle={togglePromo}
                            inputValue={promoCode}
                            onInputChange={(e) => setPromoCode(e.target.value)}
                            placeholder="Промокод"
                        />
                    </>)}

                    <button
                        type="submit"
                        className="btn btn-brown-noLine w-100 d-flex justify-content-center align-items-center"
                        disabled={!privacyAccepted || isSubmitting || isLoading}
                    >
                        {(isSubmitting || isLoading) && (
                            <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                            ></span>
                        )}
                        {isSubmitting || isLoading ? "Подождите..." : "Записаться"}
                    </button>
                    <PrivacyAgreement privacyAccepted={privacyAccepted} setPrivacyAccepted={setPrivacyAccepted} />
                </form>
            </FadeIn>

            <PlayersModal
                scheduleId={selectedGame?.id}
                heroIds={friendIds}
                setHeroIds={setFriendIds}
                isOpen={isModeModalOpen}
                onClose={() => setIsModeModalOpen(false)}
                onSubmit={handleGoingPlayer}
                isCyber={isCyber}
            />

            {/* ─── модалка для CLOSED игр ────────────────────────── */}
            <Modal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onConfirm={ pay }
                textConfirm={modalConfirmText}
                textCancel={modalCancelText}
            >
                <h3 className="text-center">{modalText}</h3>
            </Modal>

        </>
    );
};

export default Form;
